const SERVER_IP_LOCAL = "localhost:3977";
const SERVER_IP = "api.educajob.net";
let DEVELOPMENT = false;

const BASE_PATH = DEVELOPMENT
  ? `http://${SERVER_IP_LOCAL}`
  : `https://${SERVER_IP}`;
const BASE_API = DEVELOPMENT
  ? `http://${SERVER_IP_LOCAL}/api/v1`
  : `https://${SERVER_IP}/api/v1`;
const HUB_PATH = "https://educa360.org";
export const ENV = {
  HUB_PATH: HUB_PATH,
  BASE_PATH: BASE_PATH,
  BASE_API: BASE_API,
  TINY_APIKEY: "axwxvfkvpwnsjjklezf97dbrjvbnsp4pe5028x05xgv0msow",
  PATH_GLB:
    "https://repopublic-educa360.s3.eu-south-2.amazonaws.com/adminweb/glb/",
  API_ROUTES: {
    REGISTER: "auth/register",
    REGISTER_PENDING: "auth/registerPending",
    VERIFY_REGISTRATION: "auth/verifyRegistration",
    VERIFY: "auth/verify",
    RESEND_CODE: "auth/resendCode",
    LOGIN: "auth/login",
    REFRESH_ACCESS_TOKEN: "auth/refresh_access_token",
    FORGOT_PASSWORD: "auth/forgot-password",
    RESET_PASSWORD: "auth/reset-password",
    USER_ME: "user/me",
    USER: "user",
    USERS: "users",
    MENU: "menu",
    COURSE: "course",
    COURSES: "courses",
    NEWSLETTER: "newsletter",
    POSTS: "posts",
    POST: "post",
    ASSISTANCE: "assistanteduca",
    ASSISTANCES: "assistanteduca",
    THREAD: "thread",
    THREADGET: "threadGet",
    THREADEDUCA: "threadEduca",
    THREADGETEDUCA: "threadGetEduca",
    CLIENTDB: "clientdb",
    CLIENTSDB: "clientsdb",
    THREEJSIA: "threejs",
    GETTEXT_TO_SPEECH: "speechToText",
    SCENEFILE: "virtualscene/uploadimage",
    SCENEREPO: "virtualscene/uploadrepo",
    HUBROOMS: "roomshub",
    LOADROOMS: "roomshub/load",
    CONTACT: "contacts", //HOLDED CREATE CONTACT
    INSTITUTION: "institution", //HOLDED CREATE INSTITUTION
    INSTITUTIONBYINSTITUTION: "institutionprofile", //HOLDED CREATE INSTITUTION
    PLANS: "plans",
    QUIZZES: "quizzes",
  },
  JWT: {
    ACCESS: "access",
    REFRESH: "refresh",
  },
  USER: {
    ID: "id",
    CODE: "code",
  },
  homepage: "https://api.educajob.net/",
};
